/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from "@angular/fire/auth";
import { AngularFireStorageModule } from '@angular/fire/storage';
import {  CommonModule } from '@angular/common';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
  NbAlertModule,
  NbInputModule,
} from '@nebular/theme';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { FormsModule } from '@angular/forms';
import { AuthGuardService } from './auth/auth-guard.service';
import { AuthService } from './auth/auth-service.service';
import { LogoutComponent } from './auth/logout/logout.component';
import { NbAuthModule } from '@nebular/auth';
import { GeoService } from './services/geo.service';
import { VerifiedAccountGuardService } from './auth/verified-account-guard.service';
import { RequestPasswordComponent } from './components/request-password/request-password.component';
import { AdminGuardService } from './auth/admin-guard.service';
import { AgentGuardService } from './auth/agent-guard.service';
import { CitizenGuardService } from './auth/citizen-guard.service';

const firebaseConfigDev = {
  apiKey: "AIzaSyA5-zyzpJ9T_vODpjHSO-43uLEE327Ut6E",
  authDomain: "its-tramites-extranet.firebaseapp.com",
  databaseURL: "https://its-tramites-extranet.firebaseio.com",
  projectId: "its-tramites-extranet",
  storageBucket: "its-tramites-extranet.appspot.com",
  messagingSenderId: "160041448097",
  appId: "1:160041448097:web:f525543b156310aacb36e0",
  measurementId: "G-CGDRY6360R",
};

const firebaseConfigClemencia = {
  apiKey: "AIzaSyBnf5SHsw359MWIdkOWaPpAIK_vklHlmno",
  authDomain: "solicitudes-imtt-clemencia.firebaseapp.com",
  databaseURL: "https://solicitudes-imtt-clemencia.firebaseio.com",
  projectId: "solicitudes-imtt-clemencia",
  storageBucket: "solicitudes-imtt-clemencia.appspot.com",
  messagingSenderId: "104452566529",
  appId: "1:104452566529:web:c944a2ca501f4da92d5a00",
  measurementId: "G-HZZPKDC5JD"
};

const firebaseConfigTurbaco = {
  apiKey: "AIzaSyAtH7dHG4T8Ix9WaWwV1FVmJq64ipLlh44",
  authDomain: "solicitudes-stt-turbaco.firebaseapp.com",
  databaseURL: "https://solicitudes-stt-turbaco.firebaseio.com",
  projectId: "solicitudes-stt-turbaco",
  storageBucket: "solicitudes-stt-turbaco.appspot.com",
  messagingSenderId: "495653266962",
  appId: "1:495653266962:web:b3653594ce46ac8dd69acb",
  measurementId: "G-V8V6G2TL27"
};

const firebaseConfigVilla = {
  apiKey: "AIzaSyCCAJsDGEoRNaW3yaTpOLBsf2ta3WMDXeU",
  authDomain: "solicitudes-datt-villadr.firebaseapp.com",
  databaseURL: "https://solicitudes-datt-villadr.firebaseio.com",
  projectId: "solicitudes-datt-villadr",
  storageBucket: "solicitudes-datt-villadr.appspot.com",
  messagingSenderId: "77174573421",
  appId: "1:77174573421:web:ca6491b15af003f8f5f264",
  measurementId: "G-JWLYN8302H"
};

const firebaseConfigSanJuan = {
  apiKey: "AIzaSyDMXLA57FJVkZGAkrnsGPTx46M-YWrG5wk",
  authDomain: "solicitudes-dttm-sanjuan.firebaseapp.com",
  databaseURL: "https://solicitudes-dttm-sanjuan.firebaseio.com",
  projectId: "solicitudes-dttm-sanjuan",
  storageBucket: "solicitudes-dttm-sanjuan.appspot.com",
  messagingSenderId: "758270417456",
  appId: "1:758270417456:web:079965b5c031cb94922bf5",
  measurementId: "G-NVVX2THXQE"
};

const firebaseConfigBolivar = {
  apiKey: "AIzaSyAz-drjjhQ_c03TildPvEAKRRTCnlB89zw",
  authDomain: "solicitudes-sdm-bolivar.firebaseapp.com",
  databaseURL: "https://solicitudes-sdm-bolivar.firebaseio.com",
  projectId: "solicitudes-sdm-bolivar",
  storageBucket: "solicitudes-sdm-bolivar.appspot.com",
  messagingSenderId: "236731910533",
  appId: "1:236731910533:web:0cb29c14c263c5ac12dcec",
  measurementId: "G-GT7P7HNTJK"
};

const firebaseConfigMagangue = {
  apiKey: "AIzaSyC8_ftbe_2ghlsDXO5Qsqs3qpMLDbA5Zf0",
  authDomain: "solicitudes-fmtt-magangue.firebaseapp.com",
  databaseURL: "https://solicitudes-fmtt-magangue.firebaseio.com",
  projectId: "solicitudes-fmtt-magangue",
  storageBucket: "solicitudes-fmtt-magangue.appspot.com",
  messagingSenderId: "347875564753",
  appId: "1:347875564753:web:432e5c8422e8256e47f9f0",
  measurementId: "G-HFHCTXMDRK"
};

const firebaseConfigQA = {
  apiKey: "AIzaSyDcHA_Z_tpmqDkv73TXtEizHLfuKGIsKjk",
  authDomain: "solicitudes-its-qa.firebaseapp.com",
  databaseURL: "https://solicitudes-its-qa.firebaseio.com",
  projectId: "solicitudes-its-qa",
  storageBucket: "solicitudes-its-qa.appspot.com",
  messagingSenderId: "1083040669509",
  appId: "1:1083040669509:web:6dc8407823b89f94b3a82c",
  measurementId: "G-NS4M9QL9PF"
};

const firebaseConfigUAT = {
  apiKey: "AIzaSyCTVQjak3MID0gEUtavApS-i_Sb3lrCsGM",
  authDomain: "solicitudes-its-uat.firebaseapp.com",
  databaseURL: "https://solicitudes-its-uat.firebaseio.com",
  projectId: "solicitudes-its-uat",
  storageBucket: "solicitudes-its-uat.appspot.com",
  messagingSenderId: "1085846279472",
  appId: "1:1085846279472:web:eddf75217a3da23c77a4f5",
  measurementId: "G-DHWJE3CN7S"
};

var _config: any;

if (window.location.href.includes('its-tramites-extranet')){
  _config = firebaseConfigDev;
}

if (window.location.href.includes('localhost')){
  _config = firebaseConfigDev;
}

if (window.location.href.includes('solicitudes-imtt-clemencia')){
  _config = firebaseConfigClemencia;
}

if (window.location.href.includes('solicitudes-stt-turbaco')){
  _config = firebaseConfigTurbaco;
}

if (window.location.href.includes('solicitudes-datt-villadr')){
  _config = firebaseConfigVilla;
}

if (window.location.href.includes('solicitudes-dttm-sanjuan')){
  _config = firebaseConfigSanJuan;
}

if (window.location.href.includes('solicitudes-sdm-bolivar')){
  _config = firebaseConfigBolivar;
}

if (window.location.href.includes('solicitudes-fmtt-magangue')){
  _config = firebaseConfigMagangue;
}

if (window.location.href.includes('solicitudes-its-qa')){
  _config = firebaseConfigQA;
}

if (window.location.href.includes('solicitudes-its-uat')){
  _config = firebaseConfigUAT;
}

//This is the configuration to use
const firebaseConfig = _config;

@NgModule({
  providers: [
    AuthGuardService, 
    VerifiedAccountGuardService,
    AdminGuardService,
    AgentGuardService,
    CitizenGuardService,
    AuthService,
    GeoService,
    BrowserModule,
    CommonModule
  ],
  declarations: [AppComponent, LogoutComponent, RequestPasswordComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFirestoreModule,
    FormsModule,
    NbInputModule,
    NbAlertModule,
    AngularFireAuthModule,
    AngularFireStorageModule,
    NbAuthModule, 
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
